<ng-container>
    <span id="htmlContainer" class="w-100" #htmlContainer>
        @if (form) {
            <div class="w-full float-left">
                <div class="grid grid-cols-7 gap-6 w-full h-full">
                    <div class="col-span-7 xl:col-span-3 relative">
                        <span class="p-8 float-left w-100">
                            <div class="prose prose-sm !max-w-100 col-span-4 mb-[20px]">
                                <h2>
                                    {{ 'label_register_statistics' | translate }}
                                </h2>
                                <p>
                                    {{ 'text_register_statistics' | translate }}
                                </p>
                            </div>
                            <span class="separator-line block mb-[30px]"></span>
                            <form [formGroup]="form" #profileInNgForm="ngForm" (keyup.enter)="addStat()">
                                <div class="grid sm:grid-cols-6 gap-6 w-full">
                                    <ng-container>
                                        <div class="col-span-6 md:col-span-3">
                                            <mat-form-field class="fuse-mat-no-subscript w-full">
                                                <mat-label>{{ 'label_application_type' | translate }}</mat-label>
                                                <mat-select
                                                    (selectionChange)="fetchStats($event.value)"
                                                    formControlName="applicationTypesManualStatisticsId"
                                                    placeholder="Tegund umsóknar"
                                                >
                                                    @for (type of types; track type) {
                                                        <mat-option [value]="type.id">
                                                            {{ type.title }}
                                                        </mat-option>
                                                    }
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-span-6 md:col-span-3">
                                            <mat-form-field class="fuse-mat-no-subscript w-full">
                                                <mat-label>{{ 'label_date' | translate }}</mat-label>
                                                <input
                                                    class="date"
                                                    formControlName="date"
                                                    matInput
                                                    placeholder="Dagsetning"
                                                    (click)="dagsetning.open()"
                                                    [matDatepicker]="dagsetning"
                                                />
                                                <mat-datepicker-toggle matSuffix [for]="dagsetning"></mat-datepicker-toggle>
                                                <mat-datepicker #dagsetning></mat-datepicker>
                                                @if (this.form?.get('dagsetning')?.hasError('required')) {
                                                    <mat-error>
                                                        {{ 'info_date_required' | translate }}
                                                    </mat-error>
                                                }
                                            </mat-form-field>
                                        </div>
                                        <div class="col-span-6">
                                            <span class="separator-line block"></span>
                                        </div>
                                        <div class="col-span-6 md:col-span-3">
                                            <mat-form-field class="fuse-mat-no-subscript w-full">
                                                <mat-label>{{ 'label_total_projects_in_status_registered' | translate }}</mat-label>
                                                <input [formControlName]="'totalProjectsInStatusRegistered'" matInput />
                                            </mat-form-field>
                                        </div>
                                        <div class="col-span-6 md:col-span-3">
                                            <mat-form-field class="fuse-mat-no-subscript w-full">
                                                <mat-label>{{ 'label_total_projects_this_year' | translate }}</mat-label>
                                                <input [formControlName]="'totalProjectsThisYear'" matInput />
                                            </mat-form-field>
                                        </div>
                                        <div class="col-span-6">
                                            <span class="separator-line block"></span>
                                        </div>
                                        <div class="col-span-6 md:col-span-2">
                                            <mat-form-field class="fuse-mat-no-subscript w-full">
                                                <mat-label>{{ 'label_total_projects_this_week' | translate }}</mat-label>
                                                <input [formControlName]="'totalProjectsThisWeek'" matInput />
                                            </mat-form-field>
                                        </div>
                                        <div class="col-span-6 md:col-span-2">
                                            <mat-form-field class="fuse-mat-no-subscript w-full">
                                                <mat-label>{{
                                                    'label_total_projects_this_week_in_status_registered' | translate
                                                }}</mat-label>
                                                <input [formControlName]="'totalProjectsThisWeekInStatusRegistered'" matInput />
                                            </mat-form-field>
                                        </div>
                                        <div class="col-span-6 md:col-span-2">
                                            <mat-form-field class="fuse-mat-no-subscript w-full">
                                                <mat-label>{{ 'label_total_projects_this_week_in_status_on_hold' | translate }}</mat-label>
                                                <input [formControlName]="'totalProjectsThisWeekInStatusOnHold'" matInput />
                                            </mat-form-field>
                                        </div>
                                        <div class="col-span-6 md:col-span-3">
                                            <mat-form-field class="fuse-mat-no-subscript w-full">
                                                <mat-label>{{ 'label_total_projects_this_week_in_status_closed' | translate }}</mat-label>
                                                <input [formControlName]="'totalProjectsThisWeekInStatusClosed'" matInput />
                                            </mat-form-field>
                                        </div>
                                        <div class="col-span-6 md:col-span-3">
                                            <mat-form-field class="fuse-mat-no-subscript w-full">
                                                <mat-label>{{
                                                    'label_total_projects_this_week_missing_electronic_signature' | translate
                                                }}</mat-label>
                                                <input [formControlName]="'totalProjectsThisWeekMissingElectronicSignature'" matInput />
                                            </mat-form-field>
                                        </div>
                                        <div class="col-span-6">
                                            <span class="separator-line block"></span>
                                        </div>
                                        <div class="col-span-6 md:col-span-3">
                                            <mat-form-field class="fuse-mat-no-subscript w-full">
                                                <mat-label>{{ 'label_date_of_oldest_project_in_status_registered' | translate }}</mat-label>
                                                <input
                                                    class="date"
                                                    formControlName="dateOfOldestProjectInStatusRegistered"
                                                    matInput
                                                    placeholder="{{ 'label_date_of_oldest_project_in_status_registered' | translate }}"
                                                    (click)="dateOldest.open()"
                                                    [matDatepicker]="dateOldest"
                                                />
                                                <mat-datepicker-toggle matSuffix [for]="dateOldest"></mat-datepicker-toggle>
                                                <mat-datepicker #dateOldest></mat-datepicker>
                                                @if (this.form?.get('dateOfOldestProjectInStatusRegistered')?.hasError('required')) {
                                                    <mat-error>
                                                        {{ 'info_date_required' | translate }}
                                                    </mat-error>
                                                }
                                            </mat-form-field>
                                        </div>
                                        <div class="col-span-6 md:col-span-3">
                                            <mat-form-field class="fuse-mat-no-subscript w-full">
                                                <mat-label>{{ 'label_period' | translate }}</mat-label>
                                                <mat-date-range-input [rangePicker]="picker">
                                                    <input matStartDate formControlName="periodFrom" placeholder="Upphafsdagsetining" />
                                                    <input matEndDate formControlName="periodTo" placeholder="Lokadagsetning" />
                                                </mat-date-range-input>
                                                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                                <mat-date-range-picker #picker></mat-date-range-picker>
                                            </mat-form-field>
                                        </div>
                                    </ng-container>
                                </div>
                                <div class="fade-in-left flex items-center justify-end mt-[20px] w-full">
                                    @if (form.dirty) {
                                        <button mat-stroked-button type="button" (click)="revertAllChanges()" [disabled]="!formEnabled">
                                            {{ 'label_cancel' | translate }}
                                        </button>
                                    }
                                    <button
                                        class="ml-4"
                                        (click)="addStat()"
                                        mat-flat-button
                                        type="submit"
                                        [color]="'primary'"
                                        [disabled]="!formEnabled"
                                    >
                                        @if (formEnabled) {
                                            <span>
                                                {{ 'label_register' | translate }}
                                            </span>
                                        }
                                        @if (!formEnabled) {
                                            <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"> </mat-progress-spinner>
                                        }
                                    </button>
                                </div>
                            </form>
                        </span>
                    </div>
                    <div
                        [ngClass]="{ hidden: stats?.data?.length <= 0 }"
                        id="tableContainerParent"
                        class="fade-in-left col-span-7 xl:col-span-4 border-l ml-2"
                    >
                        <div id="tableContainer" class="w-full sm:w-auto float-left w-full bg-basic-gray overflow-x-auto">
                            <table matSort (matSortChange)="sortData($event)" mat-table [dataSource]="stats">
                                <ng-container matColumnDef="date">
                                    <th mat-sort-header="date" mat-header-cell *matHeaderCellDef>
                                        {{ 'date_short' | translate }}
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        {{ element.date | date: 'dd.MM.yyyy' }}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="totalProjectsInStatusRegistered">
                                    <th mat-sort-header="totalProjectsInStatusRegistered" mat-header-cell *matHeaderCellDef>
                                        {{ 'label_total_projects_in_status_registered' | translate }}
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        {{ element.totalProjectsInStatusRegistered }}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="totalProjectsThisYear">
                                    <th mat-sort-header="totalProjectsThisYear" mat-header-cell *matHeaderCellDef>
                                        {{ 'label_total_projects_this_year' | translate }}
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        {{ element.totalProjectsThisYear }}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="totalProjectsThisWeek">
                                    <th mat-sort-header="totalProjectsThisWeek" mat-header-cell *matHeaderCellDef>
                                        {{ 'label_total_projects_this_week' | translate }}
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        {{ element.totalProjectsThisWeek }}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="totalProjectsThisWeekInStatusRegistered">
                                    <th mat-sort-header="totalProjectsThisWeekInStatusRegistered" mat-header-cell *matHeaderCellDef>
                                        {{ 'label_total_projects_this_week_in_status_registered' | translate }}
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        {{ element.totalProjectsThisWeekInStatusRegistered }}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="totalProjectsThisWeekInStatusOnHold">
                                    <th mat-sort-header="totalProjectsThisWeekInStatusOnHold" mat-header-cell *matHeaderCellDef>
                                        {{ 'label_total_projects_this_week_in_status_on_hold' | translate }}
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        {{ element.totalProjectsThisWeekInStatusOnHold }}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="totalProjectsThisWeekInStatusClosed">
                                    <th mat-sort-header="totalProjectsThisWeekInStatusClosed" mat-header-cell *matHeaderCellDef>
                                        {{ 'label_total_projects_this_week_in_status_closed' | translate }}
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        {{ element.totalProjectsThisWeekInStatusClosed }}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="totalProjectsThisWeekMissingElectronicSignature">
                                    <th mat-sort-header="totalProjectsThisWeekMissingElectronicSignature" mat-header-cell *matHeaderCellDef>
                                        {{ 'label_total_projects_this_week_missing_electronic_signature' | translate }}
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        {{ element.totalProjectsThisWeekMissingElectronicSignature }}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="dateOfOldestProjectInStatusRegistered">
                                    <th mat-sort-header="dateOfOldestProjectInStatusRegistered" mat-header-cell *matHeaderCellDef>
                                        {{ 'label_date_of_oldest_project_in_status_registered' | translate }}
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        {{ element.dateOfOldestProjectInStatusRegistered | date: 'dd.MM.yyyy' }}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="period">
                                    <th mat-sort-header="period" mat-header-cell *matHeaderCellDef>
                                        {{ 'label_period' | translate }}
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        {{ element.periodFrom | date: 'dd.MM.yyyy' }}
                                        -
                                        {{ element.periodTo | date: 'dd.MM.yyyy' }}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="delete">
                                    <th mat-sort-header="delete" mat-header-cell *matHeaderCellDef></th>
                                    <td mat-cell *matCellDef="let element">
                                        <button mat-icon-button type="button" (click)="deleteStat(element.id)" [matTooltip]="'Eyða'">
                                            <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_solid:trash'"></mat-icon>
                                        </button>
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="headerColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: headerColumns"></tr>
                                <tr class="mat-row" *matNoDataRow>
                                    @if (loaded) {
                                        <div class="flex items-center justify-between">
                                            <span>
                                                <div class="mt-2 ml-2 font-medium text-secondary mt-[5px]">
                                                    {{ 'text_no_statistics_found' | translate }}
                                                </div>
                                            </span>
                                        </div>
                                    }
                                </tr>
                            </table>
                            <mat-paginator
                                #tablePaginator
                                class="justify-end"
                                showFirstLastButtons
                                [pageSize]="25"
                                [pageSizeOptions]="[10, 25, 50, 100]"
                            >
                            </mat-paginator>
                        </div>
                    </div>
                </div>
            </div>
        }
    </span>
</ng-container>
